// Angular
import { Component, ViewChild, OnInit } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

// Kendo
import { IntlService } from '@progress/kendo-angular-intl';
import { DatePickerCustomMessagesComponent, DatePickerComponent } from '@progress/kendo-angular-dateinputs';

@Component({
    selector: 'formly-field-date',
    templateUrl: './date.type.component.html',
})
export class FormlyFieldDate extends FieldType implements OnInit {
    @ViewChild(DatePickerComponent, { static: true }) private datePicker: DatePickerComponent;

    public dateObj = {};

    constructor(private intl: IntlService) {
        super();
    }

    public handleChange(value: Date): void {
        this.set(this.field.key, this.intl.formatDate(value, 'yyyy-MM-dd'));
    }

    private set(path, value) {
        let schema = this.dateObj;  // a moving reference to internal objects within obj
        const pList = path.split('.');
        const len = pList.length;

        for (let i = 0; i < len - 1; i++) {
            const elem = pList[i];

            if (!schema[elem]) {
                schema[elem] = {};
            }

            schema = schema[elem];
        }

        schema[pList[len - 1]] = value;
    }

    private get(path, obj) {
        let paths = path.split('.');
        let current = obj;
        let i;

        for (i = 0; i < paths.length; ++i) {
            if (current[paths[i]] == undefined) {
                return undefined;
            } else {
                current = current[paths[i]];
            }
        }
        return current;
    }

    ngOnInit(): void {
        if (this.to.max) {
            this.datePicker.max = this.get(this.to.max, this.model);
        }

    }
}
